import { render, staticRenderFns } from "./ApplicantStatus.vue?vue&type=template&id=55840c1e"
import script from "./ApplicantStatus.vue?vue&type=script&lang=js"
export * from "./ApplicantStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports